import { Logout, SelectRecollectionStep } from 'src/constants/actionTypes'
import type { Action } from 'src/utils/reduxUtils'
import type { RecollectionState } from './types'

const getInitialState = (): RecollectionState => {
  return {
    selectedStepId: null,
  }
}

export const recollectionReducer = (
  state: RecollectionState = getInitialState(),
  action: Action<any>,
): RecollectionState => {
  switch (action.type) {
    case SelectRecollectionStep.type.SUCCESS:
      return {
        ...state,
        selectedStepId: action.payload,
      }
    case Logout.type.SUCCESS:
      return getInitialState()
    default:
      return state
  }
}
